import { render, staticRenderFns } from "./InquiryDetailBenefit.vue?vue&type=template&id=bad6f92a&scoped=true"
import script from "./InquiryDetailBenefit.vue?vue&type=script&lang=js"
export * from "./InquiryDetailBenefit.vue?vue&type=script&lang=js"
import style0 from "./InquiryDetailBenefit.vue?vue&type=style&index=0&id=bad6f92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad6f92a",
  null
  
)

export default component.exports